import { Box, Grid, IconButton, Typography } from "@mui/material";
import apiMcu from "api/mcu";
import { ReactComponent as ArrowDownIcon } from 'assets/img/ArrowDownBox.svg';
import { ReactComponent as ArrowUpIcon } from 'assets/img/ArrowUpBox.svg';
import { SearchCC } from "components/common/SearchCC";
import { BreadcrumbsCC, ContainerPage } from "components/Layout";
import LoadingBackdrop from "components/Layout/Loading/LoadingBackdrop";
import SearchPage from "components/Layout/SearchPage";
import NotFoundData from "components/NotFound";
import { PaginationButtons } from "components/Table";
import { useTableCC } from "hooks";
import moment from "moment";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { toastError } from "utils/helpers";
import TableInfoRoom from "./components/TableInfoRoom";
import { useNavigate } from "react-router-dom";
import { PATH_ROOT } from "constants/api";

export const secondsToHMS = (seconds) => {
    const h = Math.floor(seconds / 3600);
    const m = Math.floor((seconds % 3600) / 60);
    const s = seconds % 60;

    // Đảm bảo luôn có 2 chữ số
    const hh = String(h).padStart(2, '0');
    const mm = String(m).padStart(2, '0');
    const ss = String(s).padStart(2, '0');

    return `${hh}:${mm}:${ss}`;
}

const MCUStatus = () => {
    const [roomNameOrRoomCode, setRoomNameOrRoomCode] = useState();
    const [openTableArray, setOpenTableArray] = useState([]);
    const { setCurrentPage, handleChangePage, currentPage, limit } = useTableCC();
    const { t } = useTranslation();
    const [data, setData] = useState([]);
    const [total, setTotal] = useState(0);
    const [reload, setReload] = useState(false);
    const [loading, setLoading] = useState(false);
    const ref = useRef(null);
    const navigate = useNavigate();

    const apiGetListMonitorRooms = (currentPage, roomNameOrRoomCode) => {
        return apiMcu.getListMonitorRooms(currentPage, roomNameOrRoomCode);
    }

    const handleChangeRoomPage = (st, value) => {
        setOpenTableArray([]);
        handleChangePage(st, value);
    }

    useEffect(() => {
        setLoading(true);
        if(ref.current){
            clearInterval(ref.current);
        }
        ref.current = setInterval(() => {
            apiGetListMonitorRooms(currentPage, roomNameOrRoomCode)
            .then((result) => {
                setData(result?.data || []);
                setTotal(result?.total);
            })
            .catch(error => {
                toastError(t('mcu.toast.error'))
            })
            .finally(() => {
                setLoading(false);
            })
        }, 5000)

        return() => {
            clearInterval(ref.current);
        }
    // eslint-disable-next-line
    }, [currentPage, reload])
 
    return (
        <ContainerPage>
            <BreadcrumbsCC />
            <LoadingBackdrop open={loading} />
            <SearchPage>
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', width: '100%' }}>
                    <SearchCC
                        placeholder={'mcu.placeholder.enterRoomName'}
                        backgroundColor={'#FFFF'}
                        value={roomNameOrRoomCode}
                        setValue={setRoomNameOrRoomCode}
                        handleValue={(value) => {
                            setCurrentPage(0);
                            setOpenTableArray([]);  
                            setReload(prev => !prev);
                        }}
                    />
                </Box>
            </SearchPage>
            <Box sx={{ margin: '0 20px 0 20px', height: 'calc(100vh - 180px)', display: 'flex', flexDirection: 'column', overflowY: 'auto' }}>
                {
                    data?.map((item, index) => {
                        return (
                            <Box sx={{ borderBottom: '1px solid #E0E0E0', padding: '24px 0 12px 0' }}>
                                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: "space-between" }}>
                                    <Typography 
                                        sx={{ fontWeight: 700, fontSize: '20px', color: '#cb002b', cursor: 'pointer' }}
                                        onClick={() => {
                                            navigate(`${PATH_ROOT}/mcu-control/control-room/${item.roomNumber}`)
                                        }}
                                    >
                                        {item.roomName}
                                    </Typography>
                                    <IconButton
                                        aria-label="close"
                                        onClick={() => {
                                            if (openTableArray.includes(item.roomNumber)) {
                                                setOpenTableArray(prev => prev.filter(_item => _item !== item.roomNumber));
                                            } else {
                                                setOpenTableArray(prev => [...prev, item.roomNumber]);
                                            }
                                        }}
                                    >
                                        {openTableArray.includes(item.roomNumber) ? <ArrowUpIcon /> : <ArrowDownIcon />}
                                    </IconButton>
                                </Box>
                                <Grid container >
                                    <Grid item sx={{ alignContent: 'center', fontWeight: '700', height: '32px' }} xs={1.5} md={1} lg={0.4}></Grid>
                                    <Grid item sx={{ alignContent: 'center', fontWeight: '700', height: '32px' }} xs={2.6} md={2.1} lg={1.5}>{t('mcu.status.roomCode')}:</Grid>
                                    <Grid item sx={{ alignContent: 'center', fontWeight: '500', height: '32px' }} xs={2.6} md={2.1} lg={1.5}>{item.roomNumber}</Grid>
                                    <Grid item sx={{ alignContent: 'center', fontWeight: '700', height: '32px' }} xs={2.6} md={2.1} lg={1.5}>{t('mcu.status.startTime')}:</Grid>
                                    <Grid item sx={{ alignContent: 'center', fontWeight: '500', height: '32px' }} xs={2.6} md={2.5} lg={1.8}>{moment(item.startedTime).format("HH:mm:ss YYYY-MM-DD")}</Grid>
                                    <Grid item sx={{ alignContent: 'center', fontWeight: '700', height: '32px' }} xs={2.1} md={1.6} lg={1}></Grid>
                                </Grid>
                                <Grid container>
                                    <Grid item sx={{ alignContent: 'center', fontWeight: '700', height: '32px' }} xs={1.5} md={1} lg={0.4}></Grid>
                                    <Grid item sx={{ alignContent: 'center', fontWeight: '700', height: '32px' }} xs={2.6} md={2.1} lg={1.5}>{t('mcu.status.member')}:</Grid>
                                    <Grid item sx={{ alignContent: 'center', fontWeight: '500', height: '32px' }} xs={2.6} md={2.1} lg={1.5}>{item.memberCount}</Grid>
                                    <Grid item sx={{ alignContent: 'center', fontWeight: '700', height: '32px' }} xs={2.6} md={2.1} lg={1.5}>{t('mcu.status.durationTime')}:</Grid>
                                    <Grid item sx={{ alignContent: 'center', fontWeight: '500', height: '32px' }} xs={2.6} md={2.1} lg={1.5}>{secondsToHMS(item.runTimeDuration)}</Grid>
                                    <Grid item sx={{ alignContent: 'center', fontWeight: '700', height: '32px' }} xs={2.1} md={1.6} lg={1}></Grid>
                                </Grid>
                                {
                                    openTableArray.includes(item.roomNumber) &&
                                    <TableInfoRoom nodeId={item.nodeId} roomNumber={item.roomNumber}/>
                                }
                            </Box>
                        )
                    })
                }
                {total ? <PaginationButtons sxStyle={{marginTop: 'auto'}} page={currentPage} handleChangePage={handleChangeRoomPage} limit={limit} total={total} /> : <></>}
                {total === 0 && <NotFoundData />}
            </Box>

        </ContainerPage>
    )
}

export default MCUStatus;